import styled, { css } from 'styled-components';

import { type CardSizes } from '@pkg/components';

export const Wrapper = styled.div<{ $cardSize?: CardSizes }>`
    display: flex;
    flex-direction: column;
    background: linear-gradient(206.7deg, #323232 0.77%, #404148 20.42%, #242424 73.73%);
    border-radius: 10px;
    width: 100%;
    position: relative;
    z-index: 6;
    padding: 12px;

    ${({ $cardSize }) =>
        $cardSize === 'small' &&
        css`
            padding: 6px;
        `}
`;

export const Top = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 12px;
`;

export const OwnerYat = styled.div`
    border-radius: 40px;
    background-color: rgba(0, 0, 0, 0.15);
    width: 140px;
    height: 30px;
`;

export const Media = styled.div`
    border-radius: 6px;
    width: 100%;
    aspect-ratio: 1 / 1;
    background-color: rgba(0, 0, 0, 0.15);
`;

export const Info = styled.div<{ $cardSize?: CardSizes }>`
    padding: 20px 12px;
    display: flex;
    gap: 12px;
    width: 100%;

    ${({ $cardSize }) =>
        $cardSize === 'small' &&
        css`
            padding: 10px 6px;
        `}
`;

export const Thumbnail = styled.div`
    border-radius: 6px;
    width: 36px;
    height: 36px;
    background-color: rgba(0, 0, 0, 0.15);
`;

export const NameGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
`;

export const BigName = styled.div`
    border-radius: 6px;
    width: 60%;
    height: 18px;
    background-color: rgba(0, 0, 0, 0.15);
`;

export const LittleName = styled.div`
    border-radius: 6px;
    width: 30%;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.15);
`;

export const Bottom = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
`;

export const Button = styled.div`
    border-radius: 6px;
    width: 30px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.15);
`;
